// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"footer_footerBox__20xR_"};